import React, { useState, useEffect, useCallback } from 'react';
import api from '../api';

const fmtHM = (sec) => { sec = Math.max(0, sec || 0); const h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60); return h ? `${h}h ${m}m` : `${m}m`; };
const CATS = [
  { key: 'productive', label: 'Productive', color: '#059669' },
  { key: 'neutral', label: 'Neutral', color: 'var(--muted)' },
  { key: 'unproductive', label: 'Unproductive', color: '#dc2626' },
];

export default function AppProductivity() {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [savingApp, setSavingApp] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try { const { data } = await api.get('/app-usage/apps'); setApps(data); } catch {}
    setLoading(false);
  }, []);
  useEffect(() => { load(); }, [load]);

  const setCategory = async (app_name, category) => {
    setSavingApp(app_name);
    setApps(prev => prev.map(a => a.app_name === app_name ? { ...a, category } : a));
    try { await api.put('/app-categories', { app_name, category }); } catch {}
    setSavingApp(null);
  };

  const counts = apps.reduce((acc, a) => { acc[a.category] = (acc[a.category] || 0) + 1; return acc; }, {});

  return (
    <div style={{ padding: 24, maxWidth: 900, margin: '0 auto' }}>
      <h1 style={{ fontSize: 24, fontWeight: 700, color: 'var(--text)', margin: '0 0 6px' }}>App Productivity</h1>
      <p style={{ color: 'var(--muted)', fontSize: 14, margin: '0 0 20px' }}>
        Classify the apps your team uses. Apps marked <strong style={{ color: '#059669' }}>Productive</strong> count toward each employee's “Productive Apps %” on their My Work dashboard.
      </p>

      <div style={{ display: 'flex', gap: 10, marginBottom: 18, flexWrap: 'wrap' }}>
        {CATS.map(c => (
          <div key={c.key} style={{ background: 'var(--glass)', backdropFilter: 'var(--blur)', WebkitBackdropFilter: 'var(--blur)', border: '1px solid var(--glass-border)', borderRadius: 10, padding: '10px 16px', flex: 1, minWidth: 120 }}>
            <div style={{ fontSize: 22, fontWeight: 800, color: c.color }}>{counts[c.key] || 0}</div>
            <div style={{ fontSize: 12, color: 'var(--muted)' }}>{c.label}</div>
          </div>
        ))}
      </div>

      <div style={{ background: 'var(--glass)', backdropFilter: 'var(--blur)', WebkitBackdropFilter: 'var(--blur)', border: '1px solid var(--glass-border)', borderRadius: 12, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: 'var(--hairline)' }}>
              <th style={th}>Application</th>
              <th style={th}>Time tracked</th>
              <th style={{ ...th, textAlign: 'right' }}>Category</th>
            </tr>
          </thead>
          <tbody>
            {apps.map(a => (
              <tr key={a.app_name} style={{ borderBottom: '1px solid var(--hairline)' }}>
                <td style={{ ...td, fontWeight: 600, color: 'var(--text)' }}>{a.app_name}</td>
                <td style={{ ...td, color: 'var(--muted)' }}>{fmtHM(a.total_seconds)}</td>
                <td style={{ ...td, textAlign: 'right' }}>
                  <div style={{ display: 'inline-flex', border: '1px solid var(--glass-border)', borderRadius: 8, overflow: 'hidden' }}>
                    {CATS.map(c => (
                      <button key={c.key} onClick={() => setCategory(a.app_name, c.key)}
                        style={{
                          border: 'none', cursor: 'pointer', padding: '6px 12px', fontSize: 12, fontWeight: 600,
                          background: a.category === c.key ? c.color : '#fff',
                          color: a.category === c.key ? '#fff' : 'var(--muted)',
                          opacity: savingApp === a.app_name ? 0.6 : 1,
                        }}>
                        {c.label}
                      </button>
                    ))}
                  </div>
                </td>
              </tr>
            ))}
            {!loading && apps.length === 0 && (
              <tr><td colSpan={3} style={{ textAlign: 'center', color: 'var(--muted)', padding: 36 }}>
                No app usage recorded yet. Once employees run the desktop agent, the apps they use will appear here to classify.
              </td></tr>
            )}
            {loading && <tr><td colSpan={3} style={{ textAlign: 'center', color: 'var(--muted)', padding: 28 }}>Loading…</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const th = { padding: '11px 14px', textAlign: 'left', fontWeight: 600, color: 'var(--text-2)', borderBottom: '1px solid var(--glass-border)' };
const td = { padding: '11px 14px' };
